module.exports = __webpack_public_path__ + "static/media/css_logo.6b2018f5.png";